import * as React from 'react';
import { FC, useId } from 'react';
import { moneyStr } from 'app/helpers/money';
import type { Jackpot } from './types';
import locales from './locales';

type JackpotComponentProps = { jackpot: Jackpot; currency: string };

const JackpotComponent: FC<JackpotComponentProps> = ({ jackpot, currency }) => {
  const l = locales();
  const id = useId();

  return (
    <li className="jw-range_item" aria-labelledby={id}>
      <h3 className="jw-range_title" id={id}>
        {jackpot.name}
      </h3>
      <div className="jw-range_amount">
        <p>{moneyStr(jackpot.current_value, currency)}</p>
      </div>
      <div className="jw-range_info">
        <p>{`${l.hit_range}: ${jackpot.min_hit} – ${jackpot.max_hit} ${currency}`}</p>
      </div>
      <div className="jw-range_bet">
        <p>
          {l.bet_range}: <span>{`${jackpot.min_bet} – ${jackpot.max_bet} ${currency}`}</span>
        </p>
      </div>
      <div className="jw-range_image" />
    </li>
  );
};

const WrappedLottery: FC<JackpotComponentProps> = (props) => <JackpotComponent {...props} />;

export default WrappedLottery;
